import "bootswatch/dist/lumen/bootstrap.min.css";
/* import "bootstrap/dist/css/bootstrap.min.css"; */
import { HashRouter as Router, Route, Switch } from "react-router-dom";
import { Toaster } from "react-hot-toast";
import { AuthProvider } from "./context/AuthContext";
import { SocketProvider } from "./context/SocketContext";
import { TeacherProvider } from "./context/TeacherContext";
import { MediaProvider } from "./context/MediaContext";
import { StudentProvider } from "./context/StudentContext";
import InjectAxiosInterceptors from "./InjectAxiosInterceptors";
// pages
import AccountConfirmedPage from "./pages/auth/AccountConfirmedPage";
import TeacherLecturePage from "./pages/lecture/TeacherLecturePage";
import ForgotPasswordPage from "./pages/auth/ForgotPasswordPage";
import LoginPage from "./pages/auth/LoginPage";
import ProfilePage from "./pages/auth/ProfilePage";
import RegisterPage from "./pages/auth/RegisterPage";
import ResetPasswordPage from "./pages/auth/ResetPasswordPage";
import ErrorPage from "./pages/errors/ErrorPage";
import TeacherHomepage from "./pages/home/TeacherHomepage";
import StudentHomepage from "./pages/home/StudentHomepage";
import IndexPage from "./pages/IndexPage";
import NewLecturePage from "./pages/lecture/NewLecturePage";
import UpdateLecturePage from "./pages/lecture/UpdateLecturePage";
import SocketTestingPage from "./pages/SocketTestingPage";
import StudentLecturePage from "./pages/lecture/StudentLecturePage";
import NotFoundPage from "./pages/errors/NotFoundPage";
// routers
import LoggedRoute from "./routes/LoggedRoute";
import QuickRouter from "./routes/QuickRouter";
import "./styles/global.css";

//TODO: change all console logs to correct logging with levels

function App() {
  const toastOptions = {
    duration: 5000,
  };

  const unauthenticatedRoutes = {
    "/": IndexPage,
    "/login": LoginPage,
    "/register": RegisterPage,
    "/forgot-password": ForgotPasswordPage,
    "/error": ErrorPage,
    "/test": SocketTestingPage,
  };

  const authenticatedRoutes = {
    "/teacher": TeacherHomepage,
    "/student": StudentHomepage,
    "/profile": ProfilePage,
    "/new-lecture/:courseUUID": NewLecturePage,
    "/teacher/lecture/:lectureUUID": TeacherLecturePage,
    "/student/lecture/:lectureUUID": StudentLecturePage,
    "/update-lecture/:lectureUUID": UpdateLecturePage,
  };

  return (
    <Router>
      <AuthProvider>
        <TeacherProvider>
          <StudentProvider>
            <MediaProvider>
              <SocketProvider>
                <InjectAxiosInterceptors />
                <Switch>
                  {/* Unauthenticated Routes */}
                  {Object.entries(unauthenticatedRoutes).map(([path, component]) => (
                    <Route key={path} path={path} exact component={component} />
                  ))}

                  {/* Authenticated Routes */}
                  {Object.entries(authenticatedRoutes).map(([path, component]) => (
                    <LoggedRoute key={path} path={path} exact component={component} />
                  ))}

                  {/* email confirmation route */}
                  <Route path="/confirm/:confirmationCode" component={AccountConfirmedPage} />

                  {/* password reset route */}
                  <Route path="/reset-password/:resetPasswordToken" component={ResetPasswordPage} />

                  <Route path="/quick/:lectureCode" component={QuickRouter} />

                  {/* Fallback when page is not found  */}
                  <Route component={NotFoundPage} />
                </Switch>
                <Toaster position="top-right" toastOptions={toastOptions} />
              </SocketProvider>
            </MediaProvider>
          </StudentProvider>
        </TeacherProvider>
      </AuthProvider>
    </Router>
  );
}

export default App;
